import React, { useEffect, useMemo, useRef } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import useClientAutocomplete from '@src/hooks/useClientAutocomplete';

const ClientDropdown = ({
  value,
  onChange,
  label = 'Select Client',
  size = 'small',
  sx,
  autoSelectFirst = false,
  parentCompanyId,
}) => {
  const {
    options,
    loading,
    handleInputChange,
  } = useClientAutocomplete({ parentCompanyId });

  const selectedOption = useMemo(() => {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    return (
      options.find((option) => String(option.value) === String(value)) || null
    );
  }, [options, value]);

  // Optionally pick the first client once options load and nothing is selected
  const autoSelectedRef = useRef(false);
  useEffect(() => {
    if (
      autoSelectFirst
      && !autoSelectedRef.current
      && (value === '' || value === null || value === undefined)
      && options.length > 0
    ) {
      autoSelectedRef.current = true;
      onChange(options[0].value, options[0]);
    }
  }, [autoSelectFirst, options, value, onChange]);

  return (
    <Autocomplete
      fullWidth
      size={size}
      sx={sx}
      options={options}
      loading={loading}
      value={selectedOption}
      onChange={(_, option) => onChange(option?.value ?? '', option || null)}
      onInputChange={handleInputChange}
      isOptionEqualToValue={(option, selected) =>
        String(option.value) === String(selected?.value)
      }
      getOptionLabel={(option) => option?.label || ''}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={16} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ClientDropdown;
